<template>
  <div class="pixel-head">
    <Hero
      class="hero"
      heading="Pixel Head"
    />
    <PageContainer>
      <BlockContainer>
        <BlockVisual
          :blockImage="'/icons/pixel-head-primary.svg'"
          :coloredBackground="'colored-background-secondary'"
        />
        <BlockText>
          <h2 class="block-header">The Pixel Head</h2>
          <p>
            The story behind The Pixel Head is quite simple. Since we
            work with technology, our output is often expressed onscreen
            and a screen is made up of pixels. Hence, our brand mascot
            is a pixel, raised by pixels, and built by pixels.
          </p>
          <p>
            Since pixels have no gender, race or political views we
            ask you to please don't call them Pixel Man, Pixel Guy or Miss Pixel.
          </p>
          <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/pixel-head.zip">Download Pixel Head</DownloadButton>
        </BlockText>
      </BlockContainer>
      <BlockContainer>
        <BlockText :sortOrder="'three'">
          <h2>Inverted Smile</h2>
        <p>
          We prefer The Pixel Head to be portrayed in ST Orange,
          but sometimes, it will need to be inverted. These are
          the two colorways it comes in.
        </p>
        <p>Never anything else.</p>
        </BlockText>
        <BlockVisual
          :blockImage="'/icons/pixel-head-secondary.svg'"
          :coloredBackground="'colored-background-primary'"
        />
      </BlockContainer>
      <ViLinks />
    </PageContainer>
  </div>
</template>

<script>
import Hero from '../components/hero.vue';
import DownloadButton from '../components/download-button.vue';
import PageContainer from '../components/page-container.vue';
import BlockContainer from '../components/block-container.vue';
import BlockVisual from '../components/block-visual.vue';
import BlockText from '../components/block-text.vue';
import ViLinks from '../components/visual-id-links.vue';

export default {
  name: 'Info',
  components: {
    Hero,
    DownloadButton,
    PageContainer,
    BlockContainer,
    BlockVisual,
    BlockText,
    ViLinks,
  },
};
</script>


<style lang="stylus" scoped>
  @require '../style/colors'

  .pixel-head
    margin-bottom: 5rem

</style>
